import { gql } from '@apollo/client'
import { AcademyIcon, IconProps, InformationIcon, JusIaIcon, WarningIcon } from '@farol-ds/react'

import { AlertIcon_PersistentAlertBannerIconFragment } from './__generated__/alert-icon.graphql'

const iconMap: Partial<Record<string, React.ElementType>> = {
  ACADEMY: AcademyIcon,
  INFO: InformationIcon,
  WARNING: WarningIcon,
  JUS_IA: JusIaIcon,
}

interface AlertIconProps extends IconProps {
  icon?: AlertIcon_PersistentAlertBannerIconFragment | null
  size?: IconProps['size']
}

export const AlertIcon = ({ icon, size = 'md', ...rest }: AlertIconProps) => {
  if (!icon || !icon.type) return null
  const { type } = icon

  const Icon = iconMap[type]

  if (!Icon) return null

  return <Icon size={size} {...rest} />
}

AlertIcon.fragments = {
  icon: gql`
    fragment AlertIcon_persistentAlertBannerIcon on PersistentAlertBannerIcon {
      type
    }
  `,
}
